import React from "react";
import styles from "./BrandStory.module.css";

function BrandStory() {
  return (
    <section className={styles.brandStorySection}>
      {/* The Fancy Gold Line */}
      <div className={styles.divider}></div>

      <p className={styles.storyText}>
        Named in honor of our beloved grandfather Dukamo, our brand carries
        forward his legacy of dedication, love, and community. Every sip is a
        tribute to our roots, a celebration of our land, and an invitation to
        join a passionate community.
      </p>
    </section>
  );
}

export default BrandStory;
